import { authenticationConstants as authC } from 'srcReact/redux/constants/authentication'
import { authenticationService, organizationService, userService, workplaceService } from 'srcReact/services'
import { organizationActions } from 'srcReact/OrganizationPage'
import { cleanData, objectMap, setCookie } from 'srcReact/helpers/utils'
import config from 'config'
import { checkNested, isEmpty } from 'srcReact/helpers/validator'
import { appConstantSettings } from 'srcReact/appConstantSettings'

export const authenticationActions = {
  checkEmail,
  sendActivationCode,
  validateActivationCode,
  createAccount,
  sendPasswordResetLink,
  checkPasswordResetKey,
  updatePassword,
  getSSOUserInfo,
  getServerAccessToken,
  loginWithApp
}

function checkEmail(email) {
  return (dispatch) => {
    dispatch(request({ email }))

    authenticationService.checkEmail(email).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.CHECK_EMAIL_REQUEST, datas }
  }
  function success(datas) {
    return { type: authC.CHECK_EMAIL_SUCCESS, datas }
  }
  function failure(error) {
    return { type: authC.CHECK_EMAIL_FAILURE, error }
  }
}

function sendActivationCode(email, isResend = false) {
  return (dispatch) => {
    dispatch(request({ email, isResend }))

    authenticationService.sendActivationCode(email).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.SEND_ACTIVATION_CODE_REQUEST, datas, isResend }
  }
  function success(response) {
    return { type: authC.SEND_ACTIVATION_CODE_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.SEND_ACTIVATION_CODE_FAILURE, error }
  }
}

function validateActivationCode(email, activationCode) {
  return (dispatch) => {
    dispatch(request({ email, activationCode }))

    authenticationService.validateActivationCode(email, activationCode).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.VALIDATE_ACTIVATION_CODE_REQUEST, datas }
  }
  function success(response) {
    return { type: authC.VALIDATE_ACTIVATION_CODE_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.VALIDATE_ACTIVATION_CODE_FAILURE, error }
  }
}

function createAccount(params) {
  return (dispatch) => {
    dispatch(request({ params }))
    if (params.organization_id > 0) {
      if (params.apiSubdomain && params.apiSubdomain?.length > 0) {
        createAccount(dispatch, params.apiSubdomain)
      } else {
        authenticationService.getApiSubdomain(params.organization_id).then((response) => {
          const { apiSubdomain } = response
          if (apiSubdomain) {
            createAccount(dispatch, apiSubdomain)
          }
        })
      }
    } else {
      createAccount(dispatch)
    }
  }

  function createAccount(dispatch, apiSubDomain = '') {
    authenticationService.createAccount(params, apiSubDomain).then(
      (response) => {
        if (response) {
          if (response.user) {
            localStorage.setItem('user', JSON.stringify(response.user))
          }
          localStorage.removeItem('ssoOrgList')
          setCookie('uaccess_token', response.access_token, 1)
          setCookie('usr_logged', 1, 1)
          dispatch(success(response))
          dispatch(afterAccountCreation(params.id_organization, params.fromSSO))
        }
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.CREATE_ACCOUNT_REQUEST, datas }
  }
  function success(response) {
    return { type: authC.CREATE_ACCOUNT_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.CREATE_ACCOUNT_FAILURE, error }
  }
}

function afterAccountCreation(orgId, fromSSO) {
  return (dispatch) => {
    organizationService.getByUser(appConstantSettings.ORG_LIST_QTY, 1, orgId, fromSSO === 1 ? 'sso' : '').then(
      async (response) => {
        let isInvited = false
        const list = response.list
          ? objectMap(
              response.list,
              (orga) => {
                return {
                  ...orga.info,
                  ...orga.organizations_basicsettings,
                  my_access: orga.organizations_my_access
                }
              },
              true
            )
          : []

        if (!isEmpty(list)) {
          localStorage.setItem('organization_list', JSON.stringify(list))
          dispatch(organizationActions.setCurrentOrganization(list[0], false))
        } else {
          isInvited = await workplaceService.getInvites(1).then((response) => {
            if (checkNested(response, 'list') && !isEmpty(response.list)) {
              return true
            }
            return false
          })
        }
        if (!isEmpty(list)) {
          window.location = config.webUrl
        } else {
          window.location = `${config.webUrl}/0/create-organization/`
        }
      },
      (error) => {
        dispatch(logout())
      }
    )
  }
}

function sendPasswordResetLink(email) {
  return (dispatch) => {
    dispatch(request({ email }))

    authenticationService.sendPasswordResetLink(email).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.SEND_PASSWORD_RESET_LINK_REQUEST, datas }
  }
  function success(response) {
    return { type: authC.SEND_PASSWORD_RESET_LINK_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.SEND_PASSWORD_RESET_LINK_FAILURE, error }
  }
}

function checkPasswordResetKey(reset_key) {
  return (dispatch) => {
    dispatch(request({ reset_key }))

    authenticationService.checkPasswordResetKey(reset_key).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.CHECK_PASSWORD_RESET_KEY_REQUEST, datas }
  }
  function success(response) {
    return { type: authC.CHECK_PASSWORD_RESET_KEY_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.CHECK_PASSWORD_RESET_KEY_FAILURE, error }
  }
}

function updatePassword(params) {
  return (dispatch) => {
    dispatch(request({ params }))

    authenticationService.updatePassword(params).then(
      (response) => {
        dispatch(success(response))
        cleanData()
        window.location = `${config.webUrl}/auth`
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.UPDATE_PASSWORD_REQUEST, datas }
  }
  function success(response) {
    return { type: authC.UPDATE_PASSWORD_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.UPDATE_PASSWORD_FAILURE, error }
  }
}

function getSSOUserInfo(ssoKey) {
  return (dispatch) => {
    dispatch(request())

    authenticationService.getSSOUserInfo(ssoKey).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(datas) {
    return { type: authC.GET_SSO_USER_INFO_REQUEST, datas }
  }
  function success(response) {
    return { type: authC.GET_SSO_USER_INFO_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.GET_SSO_USER_INFO_FAILURE, error }
  }
}

function getServerAccessToken(grantType, clientId, clientSecret, scope = '*') {
  return (dispatch) => {
    dispatch(request())

    authenticationService.getServerAccessToken(grantType, clientId, clientSecret, scope).then(
      (response) => {
        setCookie('saccess_token', response.access_token, 30)
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: authC.GET_SERVER_TOKEN_REQUEST, response }
  }
  function success(response) {
    return { type: authC.GET_SERVER_TOKEN_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.GET_SERVER_TOKEN_FAILURE, error }
  }
}

function loginWithApp(email, password, appName, code) {
  return (dispatch) => {
    dispatch(request(email))

    userService.loginWithApp(email, password, appName, code).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(response) {
    return { type: authC.LOGIN_WITH_APP_REQUEST, response }
  }
  function success(response) {
    return { type: authC.LOGIN_WITH_APP_SUCCESS, response }
  }
  function failure(error) {
    return { type: authC.LOGIN_WITH_APP_FAILURE, error }
  }
}
